import { motion } from 'framer-motion';
import { useMemo } from 'react';

import useNavIconVariants from '../../lib/hooks/useNavIconVariants';

import { INavIcon } from './types';

export default function Overlay({ active, ...props }: INavIcon) {
  const variants = useNavIconVariants();

  const variant = useMemo(
    () => (active ? variants.active : variants.default),
    [active, variants]
  );

  return (
    <motion.svg
      initial={variants.default}
      animate={variant}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      width={20}
      height={20}
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        d="M7.17647 7.17647H12.8235M7.17647 10H12.8235M7.17647 12.8235H10M4 10C4 5.41176 5.41176 4 10 4C14.5882 4 16 5.41176 16 10C16 14.5882 14.5882 16 10 16C5.41176 16 4 14.5882 4 10Z"
        stroke="current"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </motion.svg>
  );
}
